const Blog_Enquiry = () => {
  const inputChangedHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
  };
  return (
    <div>
      <h2 className="font-secondary text-black uppercase text-[22px] lg:text-[1.8vw] mb-4 lg:mb-[1.5vw]">
        Enquiry
      </h2>

      <div className="mb-4">
        <input
          type="text"
          className={"border-[rgba(0,0,0,0.5)] text-black border p-3 w-full"}
          placeholder="Name *"
        />
      </div>
      <div className="mb-4">
        <input
          type="email"
          className={"border-[rgba(0,0,0,0.5)] text-black border p-3 w-full"}
          placeholder="Email *"
        />
      </div>

      <div className="mb-4">
        <input
          type="text"
          className={"border-[rgba(0,0,0,0.5)] text-black border p-3 w-full"}
          placeholder="Contact No. *"
        />
      </div>

      <div className="mb-4">
        <textarea
          className={
            "border-[rgba(0,0,0,0.5)] text-black border p-3 w-full focus:outline-none"
          }
          placeholder="Comments"
        ></textarea>
      </div>

      <div className="mb-4">
        <button
          className="relative z-10 table uppercase font-primary bg-black text-white p-3 lg:p-[1vw] 
        text-xs sm:text-sm lg:text-[0.938vw] overflow-hidden tracking-widest cta ease-in-out duration-500 !leading-[1] "
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default Blog_Enquiry;
